module.exports = __webpack_public_path__ + "img/ly.050ff9b0.svg";